import { render, staticRenderFns } from "./home4.vue?vue&type=template&id=481ca26c&scoped=true&"
import script from "./home4.vue?vue&type=script&lang=js&"
export * from "./home4.vue?vue&type=script&lang=js&"
import style0 from "./home4.vue?vue&type=style&index=0&id=481ca26c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ca26c",
  null
  
)

export default component.exports